import { Injectable } from '@angular/core';
import { SalesforceSyncDataForSearchingComponent } from './sync-data-confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Injectable()
export class SyncDataConfirmationModalService {
    constructor(private readonly matDialog: MatDialog) {
    }

    openConfirmation(): Observable<boolean> {
        return this.matDialog.open(SalesforceSyncDataForSearchingComponent, { width: '600px' }).afterClosed();
    }
}
